<template>
  <UiText type="small" class="mt-1 block text-neutral-500">
    {{ text }}
  </UiText>
</template>

<script setup lang="ts">
import type { HelpTextProps } from '~/components/ui/HelpText/types';

defineProps<HelpTextProps>();
</script>
